import { useState, useEffect } from 'react';
import { CheckCircle, X } from 'lucide-react'; // Make sure to install lucide-react

export const Toast = ({ 
  message = 'Successfully saved!', 
  subMessage = 'Anyone with a link can now view this file.', 
  type = 'success', 
  duration = 3000, 
  onClose 
}) => {
  const [show, setShow] = useState(true);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setShow(false);
      onClose?.();
    }, duration);
    return () => clearTimeout(timeout);
  }, [duration, onClose]);

  if (!show) return null;

  const iconMap = {
    success: <CheckCircle className="text-green-500 w-5 h-5" />,
    error: <X className="text-red-500 w-5 h-5" />,
    info: <CheckCircle className="text-blue-500 w-5 h-5" />,
    warning: <CheckCircle className="text-yellow-500 w-5 h-5" />
  };

  return (
    <div className="fixed top-4 right-4 z-50 w-[360px] bg-white border border-gray-200 shadow-xl rounded-lg flex items-start p-4 space-x-3">
      <div className="pt-1">{iconMap[type]}</div>
      <div className="flex-1">
        <p className="text-sm font-semibold text-gray-900">{message}</p>
        <p className="text-sm text-gray-500">{subMessage}</p>
      </div>
      <button
        onClick={() => {
          setShow(false);
          onClose?.();
        }}
        className="text-gray-400 hover:text-gray-600"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};
